import { useForkRef } from '@cian/react-utils';
import classNames from 'classnames';
import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { useSliderContext } from '../../utils/sliderContext';
import { useCallbackRef } from '../../utils/useCallbackRef';
import * as styles from './Scroller.css';
import { Slide } from './components/Slide';
import { useAutoScroll, useSlidesDragControls } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var Scroller = function Scroller(_ref) {
  var _initChildrenArray$cu;

  var children = _ref.children,
      onScrollEnd = _ref.onScrollEnd,
      slideWidth = _ref.slideWidth,
      columnGap = _ref.columnGap,
      slideDrag = _ref.slideDrag,
      offset = _ref.offset;
  var localScrollerRef = React.useRef(null);

  var _useSliderContext = useSliderContext(),
      contextScrollerRef = _useSliderContext.scrollerRef;

  var scrollerRef = useForkRef(localScrollerRef, contextScrollerRef);
  useAutoScroll(); // eslint-disable-next-line react-hooks/exhaustive-deps

  var handleScrollEnd = React.useCallback(debounce(100, function () {
    if (onScrollEnd) {
      onScrollEnd();
    }
  }), [onScrollEnd]);
  React.useEffect(function () {
    var scrollerRef = localScrollerRef.current;

    if (!scrollerRef) {
      return;
    }

    scrollerRef.addEventListener('scroll', handleScrollEnd, {
      passive: true
    });
    return function () {
      return scrollerRef.removeEventListener('scroll', handleScrollEnd);
    };
  }, [handleScrollEnd]);
  var childrenArray = React.Children.toArray(children);
  var initChildrenArray = useCallbackRef(function () {
    return childrenArray.slice(0, 3);
  });
  React.useEffect(function () {
    initChildrenArray.current = null;
  });

  var _useSlidesDragControl = useSlidesDragControls(slideDrag),
      onMouseDown = _useSlidesDragControl.onMouseDown,
      onMouseLeave = _useSlidesDragControl.onMouseLeave,
      onMouseUp = _useSlidesDragControl.onMouseUp,
      onMouseMove = _useSlidesDragControl.onMouseMove;

  var scroller = /*#__PURE__*/_jsx("ul", {
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onMouseMove: onMouseMove,
    ref: scrollerRef,
    className: classNames(styles['scroller'], !!slideDrag && styles['scroller--with-drag']),
    style: {
      columnGap: columnGap
    },
    children: ((_initChildrenArray$cu = initChildrenArray.current) !== null && _initChildrenArray$cu !== void 0 ? _initChildrenArray$cu : childrenArray).map(function (child, index, arr) {
      return /*#__PURE__*/_jsx(Slide, {
        marginLeft: offset && index === 0 ? offset : undefined,
        marginRight: offset && index === arr.length - 1 ? offset : undefined,
        width: slideWidth,
        index: index,
        children: child
      }, "slide_".concat(index));
    })
  });

  if (!offset) {
    return scroller;
  }

  var containerHorizontalOffset = offset && -offset;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    style: {
      marginLeft: containerHorizontalOffset,
      marginRight: containerHorizontalOffset
    },
    children: scroller
  });
};